import { render, staticRenderFns } from "./StunServer.vue?vue&type=template&id=2bcbdb5a&scoped=true&"
import script from "./StunServer.vue?vue&type=script&lang=js&"
export * from "./StunServer.vue?vue&type=script&lang=js&"
import style0 from "./StunServer.vue?vue&type=style&index=0&id=2bcbdb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcbdb5a",
  null
  
)

export default component.exports